import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import SweetAlert from "react-bootstrap-sweetalert";

const useActionConfirmation = () => {
  const { t } = useTranslation();
  const defaultProps = {show: false}
  const [confirmationProps, setConfirmationProps] = useState(defaultProps)

  const confirm = (callback, confirmValue = null) => {
    setConfirmationProps(prevProps => ({...prevProps, show: true, confirmValue: confirmValue, onConfirm: () => {
        callback()
        resetProps()
      }}))
  }

  const resetProps = () => {
    setConfirmationProps(defaultProps)
  }

  const Confirmation = ({placeholder, show, onConfirm, onCancel, confirmValue, deletion, children}) => {
    let props = {
      input: !!confirmValue,
      showCancel: true,
      title: t("confirm?"),
      confirmBtnText: t("yes"),
      confirmBtnBsStyle: "primary",
      cancelBtnText: t("cancel"),
      cancelBtnBsStyle: "light",
      onConfirm: (value) => (!confirmValue || value === confirmValue) && onConfirm(),
      placeholder: placeholder,
      onCancel: onCancel
    }
    const deleteProps = {
      confirmBtnBsStyle: "danger",
      confirmBtnText: t("delete"),
      children: children ? children : <>
        {t("irreversible")}
        <hr/>
      </>
    }
    if (deletion) {
      props = {...props, ...deleteProps}
    }
    return <>{show && <SweetAlert {...props} />}</>
  }

  return {Confirmation, confirmationProps: {...confirmationProps, onCancel: resetProps}, confirm}
}

export default useActionConfirmation
